module.exports = __webpack_public_path__ + "img/asset-04.e1c95353.svg";